module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-d2750dbef4a68dc84ca0c3a670e94d95.png";